import { parseAsString, useQueryState } from 'nuqs'
import { useAppointmentDraftStore } from '../../../features/appointment/create'
import { getMondayOfWeek, getWeekDays, getWeekRange, formatWeekLabel } from '../../../shared/lib/timeline/weekHelpers'

function toDateKey(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function parseDateKey(key: string): Date | null {
  const [y, m, d] = key.split('-').map(Number)
  if (!y || !m || !d) return null
  const date = new Date(y, m - 1, d)
  return Number.isNaN(date.getTime()) ? null : date
}

export function useTimelineWeek() {
  const [dayKey, setDayKey] = useQueryState('day', parseAsString.withDefault(''))
  const draftDate = useAppointmentDraftStore((s) => s.draft?.plannedStart)

  const resolvedDate = (() => {
    if (dayKey) {
      const parsed = parseDateKey(dayKey)
      if (parsed) return parsed
    }
    if (draftDate) {
      const parsed = new Date(draftDate)
      if (!Number.isNaN(parsed.getTime())) return parsed
    }
    return new Date()
  })()

  const monday = getMondayOfWeek(resolvedDate)
  const friday = new Date(monday)
  friday.setDate(friday.getDate() + 4)

  const weekDays = getWeekDays(monday)
  const range = getWeekRange(monday)
  const formattedLabel = formatWeekLabel(monday, friday)

  const goToPrevWeek = () => {
    const prev = new Date(monday)
    prev.setDate(prev.getDate() - 7)
    setDayKey(toDateKey(prev))
  }

  const goToNextWeek = () => {
    const next = new Date(monday)
    next.setDate(next.getDate() + 7)
    setDayKey(toDateKey(next))
  }

  return { weekDays, from: range.from, to: range.to, formattedLabel, goToPrevWeek, goToNextWeek, setDayKey }
}
